import { useEffect, useRef } from 'react';

/**
 * Creates a timeout with a pre-defined callback after a delay
 * @param callback
 * @param delay - how long until the callback is triggered; use undefined to avoid starting the timeout
 */
export default function useTimeout(callback: () => void, delay: number | undefined) {
  const timeoutRef = useRef<number | null>(null);

  const savedCallback = useRef(callback);
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current();
    if (typeof delay === 'number') {
      timeoutRef.current = window.setTimeout(tick, delay);

      if (timeoutRef.current) {
        return () => window.clearTimeout(timeoutRef.current || undefined); // || undefined for typescript
      }
    }

    return undefined;
  }, [delay]);
  return timeoutRef;
}
